import { useEffect, useState } from 'react';
import {
  AboutUsHero,
  Stats,
  TextWithImageSection,
  ContactSection,
  LoadingScreen,
} from 'components';
import {
  aboutUsPageStats,
  aboutCompannyData,
  happyUsersData,
} from 'jsonObjets';

export default function AboutUs() {
  const [loading, setLoading] = useState(true);
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';

  useEffect(() => {
    if (!pageUrl.match('#')) {
      window.scrollTo({ top: 0 });
    }
  }, [pageUrl]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {loading && <LoadingScreen />}
      <AboutUsHero />
      {/* <Stats stats={aboutUsPageStats} /> */}
      <TextWithImageSection data={aboutCompannyData} />
      <ContactSection />
      {/* <TextWithImageSection data={happyUsersData} customClasses="happy-users" /> */}
    </>
  );
}
